import React from 'react';
import './HorizontalNavBar.css';
import {
  Home,
  AccountBalanceWallet,
  SwapHoriz,
  Receipt,
  Settings,
  Notifications,
  Logout
} from '@mui/icons-material';

const HorizontalNavBar = ({ activeTab, setActiveTab }) => {
  const menuItems = [
    { id: 'overview', icon: <Home />, label: 'Overview' },
    { id: 'wallet', icon: <AccountBalanceWallet />, label: 'Wallet' },
    { id: 'exchange', icon: <SwapHoriz />, label: 'Exchange' },
    { id: 'transactions', icon: <Receipt />, label: 'Transactions' },
    { id: 'settings', icon: <Settings />, label: 'Settings' }
  ];

  return (
    <div className="horizontal-nav">
      <div className="horizontal-nav-items">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`horizontal-nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => setActiveTab(item.id)}
          >
            <div className="horizontal-nav-item-icon">{item.icon}</div>
            <div className="horizontal-nav-item-text">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalNavBar;
